export default __webpack_public_path__ + "static/1113-e36c0f5b17ca2c91179eee986eaffbe9.gif";